/**
 * Design tokens mirrored from garageiq-web/tailwind.config.js + globals.css.
 * Use these when a hex value is needed outside of NativeWind className strings
 * (StatusBar background, react-navigation theme, native StyleSheet, etc).
 */
export const colors = {
  navy:        '#1a2856',
  navyDark:    '#0f1a35',
  navyLight:   '#2a3e6f',
  charcoal:    '#2a3e6f',
  sky:         '#FF9500',
  skyLight:    '#FFB84D',
  skyDark:     '#E68800',
  cream:       '#F5F0E8',
  creamDeep:   '#EDE8DF',
  brandBlue:   '#1a2856',
  brandOrange: '#FF9500',
  brandLight:  '#F5F0E8',
  // Web's <body> background was #1B2A4A; we keep that for full-screen surfaces.
  appBackground: '#1B2A4A',
  btnPrimary:    '#4A8FD4',
  btnPrimaryHover: '#3A7BC0',
};

export const navigationTheme = {
  dark: true,
  colors: {
    primary: colors.btnPrimary,
    background: colors.appBackground,
    card: colors.navyDark,
    text: '#ffffff',
    border: 'rgba(255,255,255,0.08)',
    notification: colors.brandOrange,
  },
  fonts: {
    regular: { fontFamily: 'System', fontWeight: '400' },
    medium:  { fontFamily: 'System', fontWeight: '500' },
    bold:    { fontFamily: 'System', fontWeight: '700' },
    heavy:   { fontFamily: 'System', fontWeight: '900' },
  },
};
